/**
 * Streaming guard for the chat markdown buffer (PLT-4595).
 *
 * While a SSE chunk arrives mid-link — e.g.
 * `[Gotion High Tech](https://staging.uprightplatform.com/company/05755418-…`
 * with no closing `)` yet — `react-markdown` cannot parse it as a link
 * and falls back to rendering the raw bracketed URL. Inside a GFM
 * table that long unbroken URL stretches the cell, the table grows
 * past its container, and the layout flickers until the closing `)`
 * arrives in a later chunk.
 *
 * The fix is to hide the partial link syntax until it's complete:
 * detect a trailing unclosed `[label](url-no-spaces-no-closing-paren`
 * at the very end of the buffer and replace it with just `label`.
 * Anchored to end-of-string so completed links earlier in the message
 * are untouched. Same trick OpenAI/Anthropic chat UIs use for
 * streaming markdown.
 *
 * Lives in its own pure-helper module (no JSX, no React imports) so
 * `streaming-link-guard-spec.ts` can pin the regex without dragging
 * the ESM-only `react-markdown` chain into mocha-unit.
 */
export function hideIncompleteTrailingLink(s: string): string {
  return s.replace(/\[([^\]]*)\]\(([^)\s]*)$/, '$1');
}
